import React from 'react';
import { Icon } from '@chakra-ui/react';
import { MdHome, MdGroups, MdDevices, MdMenuBook, MdCardGiftcard, MdSettings } from 'react-icons/md';
import { FaChessKnight } from 'react-icons/fa';

import Dashboard from 'views/vdh/Dashboard';
import Users from 'views/vdh/Users';
import Questions from 'views/vdh/Questions';
import Devices from 'views/vdh/Devices';
import Rewards from 'views/vdh/Rewards';
import Battles from 'views/vdh/Battles';
import Settings from 'views/vdh/Settings';
import Profile from 'views/vdh/Profile';
import SignIn from 'views/auth/signIn';

// role: 'admin' = chỉ admin; 'both' = admin + phụ huynh. Phụ huynh KHÔNG thấy 'Người dùng'.
const routes = [
  { name: 'Đăng nhập', layout: '/auth', path: '/sign-in', role: 'both', icon: null, component: <SignIn /> },
  { name: 'Tổng quan', layout: '/admin', path: '/default', role: 'both',
    icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />, component: <Dashboard /> },
  { name: 'Người dùng', layout: '/admin', path: '/users', role: 'admin',
    icon: <Icon as={MdGroups} width="20px" height="20px" color="inherit" />, component: <Users /> },
  { name: 'Người dùng', layout: '/admin', path: '/users/:id', role: 'admin', hideInSidebar: true,
    icon: <Icon as={MdGroups} width="20px" height="20px" color="inherit" />, component: <Users /> },
  { name: 'Thiết bị', layout: '/admin', path: '/devices', role: 'both',
    icon: <Icon as={MdDevices} width="20px" height="20px" color="inherit" />, component: <Devices /> },
  // Chi tiết 1 thiết bị (mở từ danh sách) — URL riêng để refresh không văng ra list.
  { name: 'Thiết bị', layout: '/admin', path: '/devices/:id', role: 'both', hideInSidebar: true,
    icon: <Icon as={MdDevices} width="20px" height="20px" color="inherit" />, component: <Devices /> },
  { name: 'Câu hỏi', layout: '/admin', path: '/questions', role: 'admin',
    icon: <Icon as={MdMenuBook} width="20px" height="20px" color="inherit" />, component: <Questions /> },
  { name: 'Thách đấu', layout: '/admin', path: '/battles', role: 'both',
    icon: <Icon as={FaChessKnight} width="20px" height="20px" color="inherit" />, component: <Battles /> },
  { name: 'Đổi thưởng', layout: '/admin', path: '/rewards', role: 'both',
    icon: <Icon as={MdCardGiftcard} width="20px" height="20px" color="inherit" />, component: <Rewards /> },
  { name: 'Cài đặt', layout: '/admin', path: '/settings', role: 'both',
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />, component: <Settings /> },
  // Truy cập qua menu avatar góc phải, không hiện ở sidebar.
  { name: 'Hồ sơ', layout: '/admin', path: '/profile', role: 'both', hideInSidebar: true,
    icon: <Icon as={MdSettings} width="20px" height="20px" color="inherit" />, component: <Profile /> },
];
export default routes;
